// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-7959ee98]{width:100%;text-align:center;color:grey}.fn-modified[data-v-7959ee98]{display:-webkit-box;display:-webkit-flex;display:flex;position:static}", ""]);
// Exports
module.exports = exports;
